<template>
  <div class="signup-container" v-if="progress > 0">
    <v-row cols="12" class="mb-6">
      <v-col>
        <div class="signup-logo">
          <v-img :src="require('../assets/join-us.jpeg')" height="179"/>
        </div>
        <div class="signup-progress">
          <p class="progress">Step {{progress}} of 3</p>
          <h1 v-if="sidebar_title" class="sidebar-title">{{sidebar_title}}</h1>
          <h4 v-if="sidebar_subtext" style="text-align: center;">{{sidebar_subtext}}</h4>
        </div>
      </v-col>
      <v-col cols="7" class="signup-panel pa-5">
        <component v-bind:is="current_flow" />
      </v-col>
    </v-row>
  </div>
  <div v-else class="signup-container">
    <!-- v-else will display out selection form -->
    <v-row cols="12">
      <v-col>
      <h1 style="font-size: 40px; text-align: center;">Which location would you prefer?</h1>
      </v-col>
    </v-row>
    <AddressSelect></AddressSelect>
  </div>

</template>

<script>
import {mapState} from "vuex";
import AddressSelect from "@/components/AddressSelect";
import CompanyDetails from "@/components/CompanyDetails";
import EmployeeDetails from "@/components/EmployeeDetails";
import PaymentDetails from "@/components/PaymentDetails";
export default {
  name: 'Signup',
  components: {
    AddressSelect,
    CompanyDetails,
    EmployeeDetails,
    PaymentDetails,
  },
  computed: {
    ...mapState({
        progress: state => state.service_data.signup_progress,
        flow: state => state.service_data.general_signup_flow,
        current_flow: state => state.service_data.general_signup_flow[state.service_data.signup_progress],
        sidebar_title: state => state.service_data.sidebar_h1,
        sidebar_subtext: state => state.service_data.sidebar_h4,
        internalFlag: state => state.service_data.internalFlag,
    }),
  },
}
</script>
<style scoped>
  .signup-container {
    margin: auto;
    padding: 20px;
    background-color: #f1eeee;
    max-width: 960px;
    font-family: Helvetica Neue For Number,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,PingFang SC,Hiragino Sans GB,Microsoft YaHei,Helvetica Neue,Helvetica,Arial,sans-serif;
    font-size: 14px;
    line-height: 1.5;
    color: rgba(0,0,0,.65);
  }
  .signup-panel {
    border-left: 2px solid #000;
  }
  .signup-logo {
    margin: 0 auto;
    width: 275px;
    height: 179px;
  }
  .signup-progress {
    font-weight: 400;
    font-size: 20px;
    text-align: center;
  }
  .progress {
    margin: 10px 0px;
    display: block;
  }
  h1, h2, h3, h4, h5, h6 {
      margin-top: 0;
      margin-bottom: .5em;
      color: rgba(0,0,0,.85);
      font-weight: 500 !important;
  }
  .sidebar-title {
    -webkit-tap-highlight-color: rgba(0,0,0,0);
    font-family: Helvetica Neue For Number,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,PingFang SC,Hiragino Sans GB,Microsoft YaHei,Helvetica Neue,Helvetica,Arial,sans-serif;
    text-align: center;
  }
</style>

